/**
 * Conformant blank DXF skeleton — DATA PART 1 of 2 (generated).
 *
 * DO NOT HAND-EDIT. One half of the ezdxf-generated R2018 (AC1032) blank-
 * document DXF text (CRLF normalized to LF). Concatenated in order by
 * dxfBridge.conformantSkeleton.template.ts. Split only to keep each data
 * file under the 2000-line source ceiling; the two parts join with a single
 * newline to reproduce the original DXF byte-for-byte. See the template
 * barrel for full rationale.
 */
export const SKELETON_DXF_PART_1 = `330
2
100
AcDbSymbolTableRecord
100
AcDbLinetypeTableRecord
  2
Continuous
 70
0
  3

 72
65
 73
0
 40
0.0
  0
ENDTAB
  0
TABLE
  2
LAYER
  5
1
330
0
100
AcDbSymbolTable
 70
2
  0
LAYER
  5
27
330
1
100
AcDbSymbolTableRecord
100
AcDbLayerTableRecord
  2
0
 70
0
 62
7
  6
Continuous
370
-3
390
13
347
21
  0
LAYER
  5
28
330
1
100
AcDbSymbolTableRecord
100
AcDbLayerTableRecord
  2
Defpoints
 70
0
 62
7
  6
Continuous
290
0
370
-3
390
13
347
21
  0
ENDTAB
  0
TABLE
  2
STYLE
  5
5
330
0
100
AcDbSymbolTable
 70
1
  0
STYLE
  5
29
330
5
100
AcDbSymbolTableRecord
100
AcDbTextStyleTableRecord
  2
Standard
 70
0
 40
0.0
 41
1.0
 50
0.0
 71
0
 42
2.5
  3
txt
  4

  0
ENDTAB
  0
TABLE
  2
VIEW
  5
7
330
0
100
AcDbSymbolTable
 70
0
  0
ENDTAB
  0
TABLE
  2
UCS
  5
6
330
0
100
AcDbSymbolTable
 70
0
  0
ENDTAB
  0
TABLE
  2
APPID
  5
3
330
0
100
AcDbSymbolTable
 70
3
  0
APPID
  5
2A
330
3
100
AcDbSymbolTableRecord
100
AcDbRegAppTableRecord
  2
ACAD
 70
0
  0
APPID
  5
2F
330
3
100
AcDbSymbolTableRecord
100
AcDbRegAppTableRecord
  2
HATCHBACKGROUNDCOLOR
 70
0
  0
APPID
  5
30
330
3
100
AcDbSymbolTableRecord
100
AcDbRegAppTableRecord
  2
EZDXF
 70
0
  0
ENDTAB
  0
TABLE
  2
DIMSTYLE
  5
4
330
0
100
AcDbSymbolTable
 70
1
100
AcDbDimStyleTable
  0
DIMSTYLE
105
2B
330
4
100
AcDbSymbolTableRecord
100
AcDbDimStyleTableRecord
  2
Standard
 70
0
 40
1.0
 41
2.5
 42
0.625
 43
3.75
 44
1.25
 45
0.0
 46
0.0
 47
0.0
 48
0.0
 49
2.5
140
2.5
141
2.5
142
0.0
143
0.03937007874
144
1.0
145
0.0
146
1.0
147
0.625
148
0.0
 69
0
 70
0
 71
0
 72
0
 73
0
 74
0
 75
0
 76
0
 77
1
 78
8
 79
3
170
0
171
3
172
1
173
0
174
0
175
0
176
0
177
0
178
0
179
2
271
2
272
2
273
2
274
3
275
0
276
0
277
2
278
44
279
0
280
0
281
0
282
0
283
0
284
8
285
0
286
0
288
0
289
3
290
0
371
-2
372
-2
  0
ENDTAB
  0
TABLE
  2
BLOCK_RECORD
  5
9
330
0
100
AcDbSymbolTable
 70
2
  0
BLOCK_RECORD
  5
17
330
9
100
AcDbSymbolTableRecord
100
AcDbBlockTableRecord
  2
*Model_Space
340
1A
 70
0
280
1
281
0
  0
BLOCK_RECORD
  5
1B
330
9
100
AcDbSymbolTableRecord
100
AcDbBlockTableRecord
  2
*Paper_Space
340
1E
 70
0
280
1
281
0
  0
ENDTAB
  0
ENDSEC
  0
SECTION
  2
BLOCKS
  0
BLOCK
  5
18
330
17
100
AcDbEntity
  8
0
100
AcDbBlockBegin
  2
*Model_Space
 70
0
 10
0.0
 20
0.0
 30
0.0
  3
*Model_Space
  1

  0
ENDBLK
  5
19
330
17
100
AcDbEntity
  8
0
100
AcDbBlockEnd
  0
BLOCK
  5
1C
330
1B
100
AcDbEntity
  8
0
100
AcDbBlockBegin
  2
*Paper_Space
 70
0
 10
0.0
 20
0.0
 30
0.0
  3
*Paper_Space
  1

  0
ENDBLK
  5
1D
330
1B
100
AcDbEntity
  8
0
100
AcDbBlockEnd
  0
ENDSEC
  0
SECTION
  2
ENTITIES
  0
ENDSEC
  0
SECTION
  2
OBJECTS
  0
DICTIONARY
  5
A
330
0
100
AcDbDictionary
281
1
  3
ACAD_COLOR
350
B
  3
ACAD_GROUP
350
C
  3
ACAD_LAYOUT
350
D
  3
ACAD_MATERIAL
350
E
  3
ACAD_MLEADERSTYLE
350
F
  3
ACAD_MLINESTYLE
350
10
  3
ACAD_PLOTSETTINGS
350
11
  3
ACAD_PLOTSTYLENAME
350
12
  3
ACAD_SCALELIST
350
14
  3
ACAD_TABLESTYLE
350
15
  3
ACAD_VISUALSTYLE
350
16
  3
EZDXF_META
350
2D
  0
DICTIONARY
  5
B
330
A
100
AcDbDictionary
281
1
  0
DICTIONARY
  5
C
330
A
100
AcDbDictionary
281
1
  0
DICTIONARY
  5
D
330
A
100
AcDbDictionary
281
1
  3
Model
350
1A
  3
Layout1
350
1E
  0
DICTIONARY
  5
E
330
A
100
AcDbDictionary
281
1
  3
ByBlock
350
1F
  3
ByLayer
350
20
  3
Global
350
21
  0
DICTIONARY
  5
F
330
A
100
AcDbDictionary
281
1
  3
Standard
350
2C
  0
DICTIONARY
  5
10
330
A
100
AcDbDictionary
281
1
  3
Standard
350
22
  0
DICTIONARY
  5
11
330
A
100
AcDbDictionary
281
1
  0
ACDBDICTIONARYWDFLT
  5
12
330
A
100
AcDbDictionary
281
1
  3
Normal
350
13
100
AcDbDictionaryWithDefault
340
13
  0
ACDBPLACEHOLDER
  5
13
330
12
  0
DICTIONARY
  5
14
330
A
100
AcDbDictionary
281
1
  0
DICTIONARY
  5
15
330
A
100
AcDbDictionary
281
1
  0
DICTIONARY
  5
16
330
A
100
AcDbDictionary
281
1
  0
LAYOUT
  5
1A
330
D
100
AcDbPlotSettings
  1

  4
A3
  6

 40
7.5
 41
20.0
 42
7.5
 43
20.0
 44
420.0
 45
297.0
 46
0.0
 47
0.0
 48
0.0
 49
0.0
140
0.0
141
0.0
142
1.0
143
1.0
 70
1024
 72
1
 73
0
 74
5
  7

 75
16
 76
0
 77
2
 78
300
147
1.0
148
0.0
149
0.0
100
AcDbLayout
  1
Model
 70
1
 71
0
 10
0.0
 20
0.0
 11
420.0
 21
297.0
 12
0.0
 22
0.0
 32
0.0
 14
1e+20
 24
1e+20
 34
1e+20
 15
-1e+20
 25
-1e+20
 35
-1e+20
146
0.0
 13
0.0
 23
0.0
 33
0.0
 16
1.0
 26
0.0
 36
0.0
 17
0.0
 27
1.0
 37
0.0
 76
1
330
17
  0
LAYOUT
  5
1E
330
D
100
AcDbPlotSettings
  1

  4
A3
  6

 40
7.5
 41
20.0
 42
7.5
 43
20.0
 44
420.0
 45
297.0
 46
0.0
 47
0.0
 48
0.0
 49
0.0
140
0.0
141
0.0
142
1.0
143
1.0
 70
0
 72
1
 73
0
 74
5
  7

 75
16
 76
0
 77
2
 78
300
147
1.0
148
0.0
149
0.0
100
AcDbLayout
  1
Layout1
 70
1
 71
1
 10
0.0
 20
0.0
 11
420.0
 21
297.0
 12
0.0
 22
0.0
 32
0.0
 14
1e+20
 24
1e+20
 34
1e+20
 15
-1e+20
 25
-1e+20
 35
-1e+20
146
0.0
 13
0.0
 23
0.0
 33
0.0
 16
1.0
 26
0.0
 36
0.0
 17
0.0
 27
1.0
 37
0.0
 76
1
330
1B
  0
MATERIAL
  5
1F
102
{ACAD_REACTORS
330
E
102
}
330
E
100
AcDbMaterial
  1
ByBlock
  2

 70
0
 40
1.0
 71
1
 41
1.0
 91
-1023410177
 42
1.0
 72
1
  3

 73
1
 74
1
 75
1
 44
0.5
 73
0
 45
1.0
 46
1.0
 77
1
  4

 78
1
 79
1
170
1
 48
1.0
171
1
  6

172
1
173
1
174
1
140
1.0
141
1.0
175
1
  7

176
1
177
1
178
1
143
1.0
179
1
  8

270
1
271
1
272
1
145
1.0
146
1.0
273
1
  9

274
1
275
1
276
1
 42
1.0
 72
1
  3

 73
1
 74
1
 75
1
 94
63
  0
MATERIAL
  5
20
102
{ACAD_REACTORS
330
E
102
}
330
E
100
AcDbMaterial
  1
ByLayer
  2

 70
0
 40
1.0
 71
1
 41
1.0
 91
-1023410177
 42
1.0
 72
1
  3

 73
1
 74
1
 75
1
 44
0.5
 73
0
 45
1.0
 46
1.0
 77
1
  4

 78
1
 79
1
170
1
 48
1.0
171
1
  6

172
1
173
1
174
1
140
1.0
141
1.0
175
1
  7

176
1
177
1
178
1
143
1.0
179
1
  8

270
1
271
1
272
1
145
1.0
146
1.0
273
1
  9

274
1
275
1
276
1
 42
1.0
 72
1
  3

 73
1
 74
1
 75
1
 94
63
  0
MATERIAL
  5
21
102
{ACAD_REACTORS
330
E
102
}
330
E
100
AcDbMaterial
  1
Global
  2

 70
0
 40
1.0
 71
1
 41
1.0
 91
-1023410177
 42
1.0
 72
1
  3

 73
1
 74
1
 75
1
 44
0.5
 73
0
 45
1.0
 46
1.0
 77
1
  4

 78
1
 79
1
170
1
 48
1.0
171
1
  6

172
1
173
1
174
1
140
1.0
141
1.0
175
1
  7

176
1
177
1
178
1
143
1.0
179
1
  8

270
1
271
1
272
1
145
1.0
146
1.0
273
1
  9

274
1
275
1
276
1
 42
1.0
 72
1
  3

 73
1
 74
1
 75
1
 94
63
  0
MLINESTYLE
  5
22
102
{ACAD_REACTORS
330
10
102
}
330
10
100
AcDbMlineStyle
  2
Standard
 70
0
  3

 62
256
 51
90.0
 52
90.0
 71
2
 49
0.5
 62
256
  6
BYLAYER
 49
-0.5
 62
256
  6
BYLAYER
  0
MLEADERSTYLE
  5
2C
102
{ACAD_REACTORS
330
F
102
}
330
F
100
AcDbMLeaderStyle
179
2
170
2
171
1
172
0
 90
2
 40
0.0
 41
0.0
173
1
 91
-1056964608
 92
-2
290
1
 42
2.0
291
1
 43
8.0
  3
Standard
 44
4.0
300

342
29
174
1
175
1
176
0
178
1
 93
-1056964608
 45
4.0
292
0
297
0
 46
4.0
 94
-1056964608
 47
1.0
 49
1.0
140
1.0
294
1
141
0.0
177
0
142
1.0
295
0
296
0
143
3.75
271
0
272
9
273
9
  0
DICTIONARY
  5
2D
330
A
100
AcDbDictionary
280
1
281
1
  3
CREATED_BY_EZDXF
350
2E
  3
WRITTEN_BY_EZDXF
350
31
  0
DICTIONARYVAR
  5
2E
330
2D
100
DictionaryVariables
280
0
  1
1.4.3 @ 2026-07-01T19:57:16.857335+00:00
  0
DICTIONARYVAR
  5
31
330
2D
100
DictionaryVariables
280
0
  1
1.4.3 @ 2026-07-01T19:57:16.859369+00:00
  0
ENDSEC
  0
EOF
`;
